import FileAttachmentDialog from './FileAttachmentDialog';

export default FileAttachmentDialog;
